import { withPrefix } from '@/checkout-instore-legacy/utils/withPrefix'

export const INSTORE_MAIN_URL = withPrefix('/checkout/instore')
